import "./bootstrap.css";
import React from "react";

export default function GridItem({ sizes, children }) {
  return <div className={`col ${sizes && sizes.join(" ")}`}>{children}</div>;
}
